import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { RecentlySelectedIcon } from 'foundations-assets';
import { CONTENT_INLINE_MARGIN } from '../constants/styling';
import { CategoryHeader } from './categories/CategoryHeader';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ANALYTICS_SUITE_CATEGORY_IDS } from '../constants/navigation';
import { useTemplateNavigation } from '../hooks/useTemplateNavigation';
import { Link } from 'foundations-components/transitional/components/Link';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { getRecentlyViewedSubAppKeysForHomePage } from '../../utils/recentlyViewedTemplatesUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RecentlyViewed = () => {
  const {
    navigateToTemplate
  } = useTemplateNavigation();
  const {
    tabId
  } = useParams();
  const recentlyViewedSubApps = useMemo(() => getRecentlyViewedSubAppKeysForHomePage(tabId), [tabId]);
  const handleTemplateClick = subAppKey => {
    //TODO: Track event
    navigateToTemplate(subAppKey);
  };
  if (recentlyViewedSubApps.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(CategoryHeader, {
      id: ANALYTICS_SUITE_CATEGORY_IDS.RECENTLY_VIEWED,
      labelKey: 'reports.collectionHomes.recentlyViewed',
      seeAll: false
    }), /*#__PURE__*/_jsx(Flex, {
      gap: "500",
      flexDirection: "row",
      flexWrap: "wrap",
      marginInline: CONTENT_INLINE_MARGIN,
      children: recentlyViewedSubApps.map(subAppKey => /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: RecentlySelectedIcon,
          color: "icon-interactive-default",
          padding: "0",
          marginInlineEnd: "200"
        }), /*#__PURE__*/_jsx(Link, {
          truncate: true,
          onClick: () => handleTemplateClick(subAppKey),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `reports.suiteContents.${subAppKey}.title`
          })
        })]
      }, subAppKey))
    })]
  });
};